import React, { useState } from "react";
import Images from "../../../assets/images/index.jsx"
import Icons from "../../../assets/icons/index.jsx";
import { decrypt } from "../../../utils/crypto.jsx";
import { useNavigate } from "react-router-dom";
import { profileCheck } from "../../../utils/logout.jsx";

function Header({onOpen}) {
    const navigate = useNavigate()
    if((localStorage.getItem('profileDetails'))=='undefined' || (localStorage.getItem('profileDetails'))=='' || (localStorage.getItem('profileDetails'))=='null' || localStorage.getItem('profileDetails')=='{}' || decrypt(localStorage.getItem('profileDetails'))=={} || decrypt(localStorage.getItem('profileDetails'))==undefined || decrypt(localStorage.getItem('profileDetails'))==null || decrypt(localStorage.getItem('profileDetails'))==''){
        profileCheck(navigate)
    }
    const [image,setImage]= useState((decrypt(localStorage.getItem('profileDetails')) !== undefined?JSON.parse(decrypt(localStorage.getItem('profileDetails'))):''));
    return (
        <header className="header_navbar">
            <nav className="navbar navbar-expand-lg navbar-light">
                <span class="menubar" onClick={(e) => onOpen()}>
                    <img src={Images.Menu} alt="menubar" class="img-fluid" />
                </span>
                <a className="navbar-brand" href="/">
                    <img src={Images.LogoImage} alt="Logo" className="img-fluid" />
                </a>
                {/* <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button> */}
                <div className="navbar-collapse top_linkss" id="navbarSupportedContent">
                    {/* <ul className="navbar-nav">
                        <li className="nav-item">
                            <input type="text" id="" className="form-control" placeholder="Search for videos, qbanks and tests" />
                            <span className="search_icon">
                                <img src={Icons.SearchIcon} alt="search" className="img-fluid" />
                            </span>
                        </li>
                    </ul> */}
                    <ul type="none" className="navbar-nav side_img ml-auto">
                        <li>
                            <a href="/#/account/editProfile" className="usr_image">
                                <img src={image&&image.avatar?image.avatar:Icons.UserPic} alt="userimage" className="img-fluid" />
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </header>
    )
}

export default Header;